<script lang="ts">
	import { getDayString } from '../src/date-parser';
    import type { QuizQuestion } from '../src/schema';
	import Card from './Card.svelte';

    export let date: string;
	export let questionsAndAnswers: QuizQuestion[];

	const day = getDayString(date);

	const totalScore = questionsAndAnswers.map((q) => q.points).reduce((sum, x) => sum + x);
	let answers: Array<boolean | undefined> = Array(questionsAndAnswers.length).fill(undefined); // true => correct
	let currentScore = 0;
	let showToast = false;

	$: allQuestionsAnswered = answers.every((x) => x !== undefined);

	function onAnswer(index: number, correct: boolean) {
		answers[index] = correct;
		answers = [...answers];
		computeScore();
	}

	function computeScore() {
		let newScore = 0;
		for (let index = 0; index < questionsAndAnswers.length; index++) {
			if (answers[index] === true) {
				newScore += questionsAndAnswers[index].points;
			}
		}
		currentScore = newScore;
	}

	function onShare() {
		const date2 = date.split(',')[0]; // Remove year.
		const s = `SuperQuiz ${date2}: ${currentScore}/${totalScore}\nsuperquiz.silvo.dev`;
		console.log(s);
		navigator.clipboard.writeText(s);
		showToast = true;
		setTimeout(() => {
			showToast = false;
		}, 3000);
	}
</script>

<div class="page">
	<a href="/" class="back-btn">
		<span class="material-symbols-rounded icon">arrow_back</span>
		All quizzes
	</a>

	<h1>SuperQuiz</h1>
	<h2>{day} {date}</h2>

	<div class="card-wrapper">
		{#each questionsAndAnswers as questionAndAnswer, index}
			<Card
				question={questionAndAnswer.question}
				answer={questionAndAnswer.answer}
				points={questionAndAnswer.points}
				{index}
				onUpdate={(correct) => onAnswer(index, correct)}
			/>
		{/each}

		<div class="score">
			<p>Your total score</p>
			<span class="current">{currentScore}</span>&nbsp;
			<span class="total">/&nbsp;{totalScore}</span>
		</div>

		{#if allQuestionsAnswered}
			<div>
				<button class="share-button" on:click={onShare}>
					<span class="material-symbols-rounded icon">share</span>
					<span>Share score</span>
				</button>
			</div>
		{/if}
	</div>
</div>

<div class="toast" class:visible={showToast}>Copied to clipboard</div>

<style>
	.page {
		background-color: #911eba;
		padding: 16px;
	}

	h1 {
		color: #fff;
		margin-bottom: 0;
	}

	.back-btn {
		color: #f8f0ff;
		display: flex;
		align-items: center;
		gap: 8px;
		padding-top: 4px;
	}

	.card-wrapper {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.score {
		background-color: #f8f0ff;
		display: flex;
		flex-direction: row;
		border-radius: 4px;
		padding: 8px 16px;
		align-items: center;
	}

	.score p {
		color: #111;
		flex-grow: 1;
		font-size: 16px;
		line-height: 24px;
	}

	.current {
		font-size: 24px;
		line-height: 32px;
		color: #b5179e;
	}

	.total {
		font-size: 24px;
		line-height: 32px;
		color: #333;
	}

	.share-button {
		width: 100%;
		background-color: #f8f0ff;
		border: none;
		border-radius: 4px;
		font-size: 16px;
		line-height: 20px;
		padding: 16px 16px;
		cursor: pointer;
		font-family: 'Inter', sans-serif;
		font-weight: 500;
	}

	.share-button .icon {
		padding-right: 8px;
	}

	.share-button span {
		vertical-align: middle;
	}

	.toast {
		visibility: hidden;
		opacity: 0%;
		background-color: #b6eec1;
		position: fixed;
		z-index: 1;
		width: calc(100% - 48px);
		padding: 12px;
		border: none;
		border-radius: 4px;
		top: 12px;
		left: 24px;
		text-align: center;
		box-sizing: border-box;
		box-shadow: 5px 5px 5px #3335;
		transition: opacity 0.4s;
	}

	.toast.visible {
		opacity: 100%;
		visibility: visible;
	}
</style>
